import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HeaderSCI from './HeaderSCI';
import './controlinterno.css';

const CarpetasDigitales = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  
  // Estado para almacenar el año y la categoría seleccionada
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  // Años y enlaces
  const years = [
     { year: 2022, to: '/ControlInterno/CarpetasDigitales/2022' },
    { year: 2023, to: '/ControlInterno/CarpetasDigitales/2023' },
    { year: 2024, to: '/ControlInterno/CarpetasDigitales/2024' },
    { year: 2025, to: '/ControlInterno/CarpetasDigitales/2025' },
    { year: 2026, to: '/ControlInterno/CarpetasDigitales/2025' },
  ];

  // Categorías
  const categories = [
  
    // { year: 2022, label: 'Primera Sesión Ordinaria', bgColor: '#691C32', pdfUrl: '/micro/cardigital2022/Primera_Sesion_Ordinaria_2022.pdf' },
    // { year: 2022, label: 'Segunda Sesión Ordinaria', bgColor: '#8F345A', pdfUrl: '/micro/cardigital2022/Segunda_Sesion_Ordinaria_2022.pdf' },
    // { year: 2022, label: 'Tercera Sesión Ordinaria', bgColor: '#B9859A', pdfUrl: '/micro/cardigital2022/Tercera_Sesion_Ordinaria_2022.pdf' },
    // { year: 2022, label: 'Cuarta Sesión Ordinaria', bgColor: '#A89968', pdfUrl:  '/micro/cardigital2022/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    
   
    // { year: 2022, label: 'Reuniones de Trabajo',     bgColor: '#6DA3BD', pdfUrl:'/micro/cardigital2022/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    // { year: 2022, label: 'Capacitaciones',           bgColor: '#746666', pdfUrl:'/micro/cardigital2022/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    // { year: 2022, label: 'Control Interno',          bgColor: '#6F5400', pdfUrl:'/micro/cardigital2022/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    // { year: 2022, label: 'Administración de Riesgos',bgColor: '#7F7817', pdfUrl:'/micro/cardigital2022/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },


    {
        year: 2022,
        label: 'Cuarta Sesión Ordinaria',
        bgColor: '#A89968',

        pdfs: [
          {
            label: 'Acta de Instalación',
            url: '/micro/cardigital2022/cuarta/1. ACTA DE INSTALACIÓN 2022.pdf'
          },
          {
            label: 'Acta de Cuarta Sesión',
            url: '/micro/cardigital2022/cuarta/2. ACTA DE CUARTA SESION ORDINARIA 2022.pdf'
          },
          {
            label: 'Carpeta Cuarta Sesión',
            url: '/micro/cardigital2022/cuarta/3. CARPETA CUARTA SESIÓN ORDINARIA 2022.pdf'
          }
        ]
      },


       {
        year: 2023,
        label: 'Primera Sesión Ordinaria',
        bgColor: '#691C32',

        pdfs: [
          {
            label: 'Acta Primera Sesión',
            url: '/micro/cardigital2023/primera/1. ACTA PRIMERA SESIÓN ORDINARIA 2023.pdf'
          },
          // {
          //   label: 'Acta de Cuarta Sesión',
          //   url: '/micro/cardigital2022/primera/2. ACTA DE CUARTA SESION ORDINARIA 2022.pdf'
          // },
          {
            label: 'Carpeta Primera Sesión',
            url: '/micro/cardigital2023/primera/2. CARPETA PRIMERA SESION ORIDNARIA  2023.pdf'
          }
        ]
      },

      {
        year: 2023,
        label: 'Segunda Sesión Ordinaria',
        bgColor: '#8F345A',

        pdfs: [
          {
            label: 'Acta Segunda Sesión',
            url: '/micro/cardigital2023/segunda/1. ACTA SEGUNDA SESIÓN ORIDNARIA 2023.pdf'
          },
          // {
          //   label: 'Acta de Cuarta Sesión',
          //   url: '/micro/cardigital2022/segunda/2. ACTA DE CUARTA SESION ORDINARIA 2022.pdf'
          // },
          {
            label: 'Carpeta Segunda Sesión',
            url: '/micro/cardigital2023/segunda/2. CARPETA SEGUNDA SESIÓN ORDINARIA 2023.pdf'
          }
        ]
      },


       {
        year: 2023,
        label: 'Tercera Sesión Ordinaria',
        bgColor: '#B9859A',

        pdfs: [
          {
            label: 'Acta Tercera Sesión',
            url: '/micro/cardigital2023/Tercera/1. ACTA TERCERA SESIÓN ORDINARIA 2023.pdf'
          },
          // {
          //   label: 'Acta de Cuarta Sesión',
          //   url: '/micro/cardigital2022/Tercera/2. ACTA DE CUARTA SESION ORDINARIA 2022.pdf'
          // },
          {
            label: 'Carpeta Tercera Sesión',
            url: '/micro/cardigital2023/Tercera/2. CARPETA TERCERA SESIÓN ORDINARIA 2023.pdf'
          }
        ]
      },
  
     
   

      {
        year: 2023,
        label: 'Cuarta Sesión Ordinaria',
        bgColor: '#A89968',

        pdfs: [
          {
            label: 'Acta Cuarta Sesión',
            url: '/micro/cardigital2023/Cuarta/1. ACTA DE CUARTA SESIÓN ORDINARIA 2023.pdf'
          },
          // {
          //   label: 'Acta de Cuarta Sesión',
          //   url: '/micro/cardigital2022/Cuarta/2. ACTA DE CUARTA SESION ORDINARIA 2022.pdf'
          // },
          {
            label: 'Carpeta Cuarta Sesión',
            url: '/micro/cardigital2023/Cuarta/2. CARPETA CUARTA SESION ORDINARIA 2023.pdf'
          }
        ]
      }, 
    


    // { year: 2023, label: 'Reuniones de Trabajo',     bgColor: '#6DA3BD', pdfUrl:'/micro/cardigital2023/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    // { year: 2023, label: 'Capacitaciones',           bgColor: '#746666', pdfUrl:'/micro/cardigital2023/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    // { year: 2023, label: 'Control Interno',          bgColor: '#6F5400', pdfUrl:'/micro/cardigital2023/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    // { year: 2023, label: 'Administración de Riesgos',bgColor: '#7F7817', pdfUrl:'/micro/cardigital2023/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },




     {
        year: 2024,
        label: 'Primera Sesión Ordinaria',
        bgColor: '#691C32',

        pdfs: [
          {
            label: 'Acta Primera Sesión',
            url: '/micro/cardigital2024/primera/1. ACTA PRIMERA SESIÓN ORDINARIA 2024.pdf'
          },
          // {
          //   label: 'Acta de Cuarta Sesión',
          //   url: '/micro/cardigital2022/primera/2. ACTA DE CUARTA SESION ORDINARIA 2022.pdf'
          // },
          {
            label: 'Carpeta Primera Sesión',
            url: '/micro/cardigital2024/primera/2. CARPETA PRIMERA SESIÓN ORDINARIA 2024.pdf'
          }
        ]
      },

      {
        year: 2024,
        label: 'Segunda Sesión Ordinaria',
        bgColor: '#8F345A',

        pdfs: [
          {
            label: 'Acta Segunda Sesión',
            url: '/micro/cardigital2024/segunda/1. ACTA SEGUNDA SESIÓN ORDINARIA 2024.pdf'
          },
          // {
          //   label: 'Acta de Cuarta Sesión',
          //   url: '/micro/cardigital2022/segunda/2. ACTA DE CUARTA SESION ORDINARIA 2022.pdf'
          // },
          {
            label: 'Carpeta Segunda Sesión',
            url: '/micro/cardigital2024/segunda/1. ACTA SEGUNDA SESIÓN ORDINARIA 2024.pdf'
          }
        ]
      },


       {
        year: 2024,
        label: 'Tercera Sesión Ordinaria',
        bgColor: '#B9859A',

        pdfs: [
          {
            label: 'Acta Tercera Sesión',
            url: '/micro/cardigital2024/Tercera/1. ACTA TERCERA SESIÓN ORDINARIA 2024.pdf'
          },
          // {
          //   label: 'Acta de Cuarta Sesión',
          //   url: '/micro/cardigital2022/Tercera/2. ACTA DE CUARTA SESION ORDINARIA 2022.pdf'
          // },
          {
            label: 'Carpeta Tercera Sesión',
            url: '/micro/cardigital2024/Tercera/2. CARPETA TERCERA SESIÓN ORDINARIA 2024.pdf'
          }
        ]
      },
  
     
   

      {
        year: 2024,
        label: 'Cuarta Sesión Ordinaria',
        bgColor: '#A89968',

        pdfs: [
          {
            label: 'Acta Cuarta Sesión',
            url: '/micro/cardigital2024/Cuarta/1. ACTA CUARTA SESIÓN ORDINARIA 2024.pdf'
          },
          // {
          //   label: 'Acta de Cuarta Sesión',
          //   url: '/micro/cardigital2022/Cuarta/2. ACTA DE CUARTA SESION ORDINARIA 2022.pdf'
          // },
          {
            label: 'Carpeta Cuarta Sesión',
            url: '/micro/cardigital2024/Cuarta/2. CARPETA CUARTA SESIÓN ORDINARIA 2024.pdf'
          }
        ]
      }, 
    
    // { year: 2024, label: 'Reuniones de Trabajo',     bgColor: '#6DA3BD', pdfUrl:'/micro/cardigital2024/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    // { year: 2024, label: 'Capacitaciones',           bgColor: '#746666', pdfUrl:'/micro/cardigital2024/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    // { year: 2024, label: 'Control Interno',          bgColor: '#6F5400', pdfUrl:'/micro/cardigital2024/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    // { year: 2024, label: 'Administración de Riesgos',bgColor: '#7F7817', pdfUrl:'/micro/cardigital2024/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },


    {
        year: 2025,
        label: 'Primera Sesión Ordinaria',
        bgColor: '#691C32',

        pdfs: [
          {
            label: 'Acta Primera Sesión',
            url: '/micro/cardigital2025/primera/1. ACTA PRIMERA SESIÓN ORDINARIA 2025.pdf'
          },
          // {
          //   label: 'Acta de Cuarta Sesión',
          //   url: '/micro/cardigital2022/primera/2. ACTA DE CUARTA SESION ORDINARIA 2022.pdf'
          // },
          {
            label: 'Carpeta Primera Sesión',
            url: '/micro/cardigital2025/primera/2. CARPETA PRIMERA SESIÓN ORDINARIA 2025.pdf'
          }
        ]
      },

      {
        year: 2025,
        label: 'Segunda Sesión Ordinaria',
        bgColor: '#8F345A',

        pdfs: [
          {
            label: 'Acta Segunda Sesión',
            url: '/micro/cardigital2025/segunda/1. ACTA SEGUNDA SESIÓN ORDINARIA 2025.pdf'
          },
          // {
          //   label: 'Acta de Cuarta Sesión',
          //   url: '/micro/cardigital2022/segunda/2. ACTA DE CUARTA SESION ORDINARIA 2022.pdf'
          // },
          {
            label: 'Carpeta Segunda Sesión',
            url: '/micro/cardigital2025/segunda/2. CARPETA SEGUNDA SESIÓN ORDINARIA 2025.pdf'
          }
        ]
      },


       {
        year: 2025,
        label: 'Tercera Sesión Ordinaria',
        bgColor: '#B9859A',

        pdfs: [
          {
            label: 'Acta Tercera Sesión',
            url: '/micro/cardigital2025/Tercera/1. ACTA TERCERA SESIÒN ORDINARIA 2025.pdf'
          },
          // {
          //   label: 'Acta de Cuarta Sesión',
          //   url: '/micro/cardigital2022/Tercera/2. ACTA DE CUARTA SESION ORDINARIA 2022.pdf'
          // },
          {
            label: 'Carpeta Tercera Sesión',
            url: '/micro/cardigital2025/Tercera/2. CARPETA TERCERA SESIÓN ORDINARIA 2025.pdf'
          }
        ]
      },
  
     
   

      {
        year: 2025,
        label: 'Cuarta Sesión Ordinaria',
        bgColor: '#A89968',

        pdfs: [
          {
            label: 'Acta Cuarta Sesión',
            url: '/micro/cardigital2025/Cuarta/1. ACTA CUARTA SESIÒN ORDINARIA 2025.pdf'
          },
          // {
          //   label: 'Acta de Cuarta Sesión',
          //   url: '/micro/cardigital2022/Cuarta/2. ACTA DE CUARTA SESION ORDINARIA 2022.pdf'
          // },
          {
            label: 'Carpeta Cuarta Sesión',
            url: '/micro/cardigital2025/Cuarta/2. CARPETA CUARTA SESIÓN ORDINARIA 2025.pdf'
          }
        ]
      }, 
    // { year: 2025, label: 'Reuniones de Trabajo',     bgColor: '#6DA3BD', pdfUrl:'/micro/cardigital2025/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    // { year: 2025, label: 'Capacitaciones',           bgColor: '#746666', pdfUrl:'/micro/cardigital2025/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    // { year: 2025, label: 'Control Interno',          bgColor: '#6F5400', pdfUrl:'/micro/cardigital2025/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    // { year: 2025, label: 'Administración de Riesgos',bgColor: '#7F7817', pdfUrl:'/micro/cardigital2025/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },


      { year: 2026, label: 'Primera Sesión Ordinaria', bgColor: '#691C32', pdfUrl: '/micro/cardigital2026/Primera_Sesion_Ordinaria_2022.pdf' },
    { year: 2026, label: 'Segunda Sesión Ordinaria', bgColor: '#8F345A', pdfUrl: '/micro/cardigital2026/Segunda_Sesion_Ordinaria_2022.pdf' },
    { year: 2026, label: 'Tercera Sesión Ordinaria', bgColor: '#B9859A', pdfUrl: '/micro/cardigital2026/Tercera_Sesion_Ordinaria_2022.pdf' },
    { year: 2026, label: 'Cuarta Sesión Ordinaria', bgColor: '#A89968', pdfUrl:  '/micro/cardigital2026/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2026, label: 'Reuniones de Trabajo',     bgColor: '#6DA3BD', pdfUrl:'/micro/cardigital2026/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2026, label: 'Capacitaciones',           bgColor: '#746666', pdfUrl:'/micro/cardigital2026/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2026, label: 'Control Interno',          bgColor: '#6F5400', pdfUrl:'/micro/cardigital2026/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2026, label: 'Administración de Riesgos',bgColor: '#7F7817', pdfUrl:'/micro/cardigital2026/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
  ];

  // Lógica para manejar la selección de año y categoría
  const handleCategoryClick = (category) => {

  // Si tiene un solo PDF, lo abre directamente
          if (category.pdfUrl) {
            window.open(category.pdfUrl, '_blank');
            return;
          }

          // Si tiene varios PDFs, muestra u oculta el submenu
          if (category.pdfs) {
            setSelectedCategory(
              selectedCategory?.year === category.year &&
              selectedCategory?.label === category.label
                ? null
                : category
            );
          }
        };

  return (
    <>
      <HeaderSCI title="CARPETAS DIGITALES Y EVIDENCIAS" />

      <div className="container" style={{ paddingBottom: '60px' }}>
        <div className="row justify-content-center">
          {years.map((y, yIdx) => (
            <div key={yIdx} className="col-lg-3 col-md-6 col-12 mb-5 d-flex flex-column align-items-center">
              {/* Year Icon Header */}
              <Link to={y.to} className="carpetas-year-header-link">
                <div className="carpetas-year-header">
                  <div className="carpetas-year-icon">
                    <i className="fa-regular fa-address-card"></i>
                  </div>
                  <h4 className="carpetas-year-title">Año {y.year}</h4>
                </div>
              </Link>

              {/* List of categories */}
              <div className="w-100 d-flex flex-column align-items-center">
              {categories
                  .filter(c => c.year === y.year)
                  .map((c, cIdx) => (

                    <div key={cIdx} className="w-100">

                      <div
                        className="carpetas-category-btn"
                        style={{ backgroundColor: c.bgColor }}
                        onClick={() => handleCategoryClick(c)}
                      >
                        {c.label}
                      </div>
                        {c.pdfs &&
                            selectedCategory?.year === c.year &&
                            selectedCategory?.label === c.label && (

                              <div
                                style={{
                                  width: '90%',
                                  margin: '5px auto 15px auto',
                                  paddingLeft: '10px'
                                }}
                              >

                                {c.pdfs.map((pdf, pdfIdx) => (

                                  <div
                                    key={pdfIdx}
                                    style={{
                                      marginBottom: '6px',
                                      fontSize: '0.9rem'
                                    }}
                                  >
                                    <a
                                      href={pdf.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        color: '#621132',
                                        textDecoration: 'none'
                                      }}
                                    >
                                      • {pdf.label}
                                    </a>
                                  </div>

                                ))}

                              </div>
                          )}
            

                    </div>

                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CarpetasDigitales;